import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from "@angular/core";
import { Router } from "@angular/router";
import { toArray, map, filter, each, find } from "lodash";
import { Location } from "@angular/common";

@Component({
  selector: "fihe-filter-box",
  templateUrl: "./filter-box.component.html",
  styleUrls: ["./filter-box.component.scss"],
})
export class FilterBoxComponent implements OnInit {
  currentFilter;
  filterList;
  visibleFilterList;
  currentMeta;
  sub2;
  $window;
  windowHeight;
  loadmorepos = -1;
  destroyed = false;
  showmap = false;
  constructor(
    private ref: ChangeDetectorRef,
    private router: Router,
    private location: Location
  ) {}

  getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
      }
    }
  }

  init() {
    this.currentFilter = window["fihe_filter"].filter;
    this.currentMeta = window["fihe_filter"];

    this.filterList = map(this.currentFilter, (item, key) => {
      item.id = key;
      return item;
    });

    if (this.currentMeta.total_by_category != this.currentMeta.total) {
      window["jQuery"](".result-counter").html(
        this.currentMeta.total + " von " + this.currentMeta.total_by_category
      );
    } else {
      window["jQuery"](".result-counter").html(this.currentMeta.total);
    }

    this.showmap = true;

    if (!this.destroyed) {
      this.ref.detectChanges();
    }
  }

  ngOnInit() {
    this.$window = window["jQuery"](window);

    if (window["fi_refresh"]) {
      window["jQuery"].ajax({
        url: window.location.pathname + window.location.search + "",
        method: "GET",
        dataType: "html",
        success: (e) => {
          this.ajaxDone(e);
          this.init();
          this.updateList();
        },
        error: this.ajaxError.bind(this),
      });
    }
    this.init();
    this.updateList();
    window["fi_refresh"] = false;

    this.$window.on("scroll", this.onScroll.bind(this));
    this.$window.on("resize", this.onResize.bind(this));
    this.$window.on("click", ".lmr-btn", this.loadNext.bind(this));
    this.onResize();
  }

  showMap = false;

  toggleMap() {
    if (this.showMap) {
      window["jQuery"](".filter-map").hide();
      window["jQuery"]("#all").removeClass("hasMap");
      this.showMap = false;
      window["showMap"] = false;
      setTimeout(() => {
        window["toggleMap"]();
      }, 50);
      try {
        if (window["ga"]) {
          window["ga"]("send", "Search", "Map", "Hide", 1);
        }
      } catch (e) {}
    } else {
      this.search("map");
      window["jQuery"](".filter-map").show();
      window["jQuery"]("#all").addClass("hasMap");
      this.showMap = true;
      window["showMap"] = true;
      setTimeout(() => {
        window["toggleMap"]();
      }, 50);

      try {
        if (window["ga"]) {
          window["ga"]("send", "Search", "Map", "Show", 1);
        }
      } catch (e) {}
    }
  }

  change() {
    this.updateList();
  }

  search(_e: any = false) {
    this.updateList();

    var params = [];

    each(this.filterList, (item) => {
      if (!item.show_if || (item.show_if && item.show)) {
        if (item.form_type == "checkbox" || item.form_type == "radio") {
          var selected = filter(item.items, (_value) => {
            return _value.checked && _value.value != -1;
          });
          if (selected && selected.length > 0) {
            each(selected, (_sel) => {
              params.push({
                name: "tx_fihedb_list[" + item.id + "][]",
                value: _sel.value,
              });
            });
          }
        } else if (item.form_type == "geo") {
          if (item.text_value && item.text_value.length > 0) {
            params.push({
              name: "tx_fihedb_list[location]",
              value: item.text_value,
            });
            var selected = find(item.items, (_value) => {
              return _value.checked && _value.value != -1;
            });
            params.push({
              name: "tx_fihedb_list[distance]",
              value: selected.value * 1,
            });
          }
        }
      }
    });

    this.isLoading = true;
    window["jQuery"]("#all").addClass("isLoading");
    window["jQuery"].ajax({
      url:
        this.currentMeta.baseurl +
        (this.showMap || _e == "map" ? "preview/" : ""),
      method: "GET",
      dataType: "html",
      data: params,
      success: (e) => {
        this.ajaxDone(e);
        this.init();
        this.updateList();
        this.isLoading = false;
        window["jQuery"]("#all").removeClass("isLoading");
        window["mapUpdate"](e);
      },
      error: this.ajaxError.bind(this),
    });

    if (_e == "map") {
      if (window["dataLayer"]) {
        window["dataLayer"].push({
          custom_event_category: "Filter",
          custom_event_action: "Karte",
          custom_event_label: "geöffnet",
          custom_event_value: 1,
          event: "custom_event",
        });
      }
    } else if (_e) {
      var cat = _e.label;
      var selected = filter(_e.items, (_value) => {
        return _value.checked && _value.value != -1;
      });
      var label = "";
      var labels = map(selected, (e) => e.label);

      if (window["dataLayer"]) {
        window["dataLayer"].push({
          custom_event_category: "Filter",
          custom_event_action: cat,
          custom_event_label: labels.join(""),
          custom_event_value: 1,
          event: "custom_event",
        });
      }
    } else {
      if (window["dataLayer"]) {
        window["dataLayer"].push({
          custom_event_category: "Filter",
          custom_event_action: "Reset",
          custom_event_label: "Alle",
          custom_event_value: 1,
          event: "custom_event",
        });
      }
    }
  }

  checkDropDown(_style) {
    if (_style) {
      window["jQuery"](".buttons-wrapper").attr("style", _style);
      window["jQuery"](".filter-toggle").removeClass("down");
    } else {
      window["jQuery"](".filter-toggle").addClass("down");
    }
  }

  ajaxDone(_e, _append = false) {
    var stylefreeze = window["jQuery"](".buttons-wrapper").attr("style");

    var page = window["jQuery"](_e);
    window["jQuery"]("#fihe_filter").remove();
    window["jQuery"]("body").append(page.find("#fihe_filter"));
    if (_append) {
      page
        .find(".duplicateresults .box")
        .appendTo(window["jQuery"](".duplicateresults"));
    } else {
      window["jQuery"](".duplicateresults").html(
        page.find(".duplicateresults").html()
      );
    }

    window["jQuery"](window).resize();
    setTimeout(() => {
      window["jQuery"](window).resize();
      this.checkDropDown(stylefreeze);
    }, 10);
    setTimeout(() => {
      window["jQuery"](window).resize();
    }, 50);
    setTimeout(() => {
      window["jQuery"](window).resize();
    }, 200);
    setTimeout(() => {
      window["jQuery"](window).resize();
    }, 1000);

    window["jQuery"]("body").trigger("favcheck");

    var parser = document.createElement("a");
    parser.href = window["fihe_filter"].uri;

    window["fi_url"] = parser.pathname + parser.search;

    if (parser.search && parser.search.length > 0) {
      var search = decodeURIComponent(parser.search.substring(1));
      var param = JSON.parse(
        '{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
        function (key, value) {
          return key === "" ? value : decodeURIComponent(value);
        }
      );

      setTimeout(() => {
        if (window["dataLayer"])
          window["dataLayer"].push({ event: "v_page_view" });
      }, 100);

      this.router.navigate([parser.pathname], { queryParams: param });
    } else {
      setTimeout(() => {
        if (window["dataLayer"])
          window["dataLayer"].push({ event: "v_page_view" });
      }, 100);

      this.router.navigate([parser.pathname]);
    }
  }

  ajaxError(e) {
    this.isLoading = false;
    window["jQuery"]("#all").removeClass("isLoading");
  }

  updateList() {
    var firstCondition = true;

    each(this.filterList, (item) => {
      // console.log(item , this.filterList);

      if (item.show_if) {
        var show = false;
        each(item.show_if, (_condition) => {
          item.preview = false;

          // Extract Condition KEy and Value
          var key = _condition.split(".")[0],
            value = _condition.split(".")[1];

          var localItem = find(this.filterList, { id: key });

          if (localItem) {
            var valItem = find(localItem.items, { value: value });

            if (valItem && valItem.checked) {
              show = true;
            } else {
              var allItem = find(localItem.items, { value: -1 });
              if (firstCondition && allItem && allItem.checked) {
                item.preview = true;
                show = true;
                //  console.log('Preview!' , item);
              }
            }
          }
        });

        item.show = show;

        firstCondition = false;
      } else {
        item.show = true;
        item.preview = false;
      }
    });

    this.visibleFilterList = filter(this.filterList, { show: true });
    //this.visibleFilterList = this.filterList

    this.checkInfinitiLoad();
    if (!this.destroyed) {
      this.ref.detectChanges();
    }
  }

  checkInfinitiLoad() {
    if (this.currentMeta.nexturl) {
      if (window["jQuery"](".lmr").length == 0) {
        window["jQuery"](
          '<div class="row lmr"><div class="small-12 columns text-center"><span class="button lmr-btn">Mehr anzeigen</span></div></div>'
        ).insertAfter(".duplicateresults");
        setTimeout(() => {
          this.onResize();
        }, 100);
        setTimeout(() => {
          this.onResize();
        }, 500);
        setTimeout(() => {
          this.onResize();
        }, 1000);
      }
    } else {
      window["jQuery"](".lmr").remove();
      this.loadmorepos = -1;
    }

    this.onResize();
  }

  onResize() {
    this.windowHeight = this.$window.height();
    this.loadmorepos =
      window["jQuery"](".lmr").length > 0
        ? window["jQuery"](".lmr").offset().top
        : -1;
  }

  isLoading = false;
  onScroll() {
    if (this.loadmorepos == -1) {
      return;
    }

    if (
      !this.isLoading &&
      this.$window.scrollTop() + this.windowHeight * 1.5 > this.loadmorepos
    ) {
      this.loadNext();
    }
  }

  loadNext() {
    this.isLoading = true;
    window["jQuery"]("#all").addClass("isLoading");
    if (this.currentMeta.nexturl) {
      window["jQuery"].ajax({
        url: this.currentMeta.nexturl,
        method: "GET",
        dataType: "html",
        success: (e) => {
          this.ajaxDone(e, true);
          this.init();
          this.updateList();
          window["jQuery"]("#all").trigger("lmrComplete");
          setTimeout(() => {
            this.isLoading = false;
            window["jQuery"]("#all").removeClass("isLoading");
          }, 1000);
        },
        error: this.ajaxError.bind(this),
      });
    }
  }

  ngOnDestroy() {
    this.destroyed = true;
    this.$window.off("scroll", this.onScroll.bind(this));
    this.$window.off("resize", this.onResize.bind(this));
  }
}



// WEBPACK FOOTER //
// ./src/app/filter-box/filter-box.component.ts